export default function Notfound(params) {
  return(
    <div>
      <h1>Insert image</h1>
      <p>From ChatGPT</p>
      <img></img>
    </div>
  )
};
